'use client';
import { Box, BoxProps } from '@mui/material';
import { fadeInUpSx } from '../../constants';

/**
 * Fades its content in while sliding it up, as customer-mobile lists do. Pass `index` to stagger list items.
 *
 * @param {number} index - Position in a list; each step delays the entrance by 60ms, capped at 8.
 */
export const FadeInUp = ({ index = 0, sx, ...rest }: BoxProps & { index?: number }) => (
  <Box sx={{ ...fadeInUpSx(index), ...sx }} {...rest} />
);
